import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AvaliableChannels from './AvailableChannels';
import { Card, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { updateAllChannels } from '../../../../redux/slices/myGymTV/entertainmentSlice.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faCompactDisc, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import './entertainment.scss';

const ReplaceAll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showAvailableChannels, setShowAvailableChannels] = useState(false);
  const handleCloseAvailableChannels = () => setShowAvailableChannels(false);
  const handleShowAvailableChannels = () => setShowAvailableChannels(true);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { selectedChannel } = useSelector((state) => state.entertainment);

  const openConfirmationModal = () => {
    setShowConfirmationModal(true);
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const handleReplaceAll = () => {
    dispatch(updateAllChannels(selectedChannel));
    closeConfirmationModal();
  }

  return (
    <Card
      className="border-0"
      id="copy-day"
    >
      <Card.Body>
        <Card.Body>
          <Card.Title className="py-2"> Replace All</Card.Title>
          <div
            className="alert alert-secondary d-flex justify-content-between align-items-center"
            role="alert"
          >
            <FontAwesomeIcon
              className="text-secondary"
              icon={faCircleInfo}
            />
            <div className="ms-2 entertainment__action-info">Choose a channel to play all day, every day.</div>
          </div>
          {selectedChannel ?
            <>
              <div className="h5 text-secondary border-bottom mt-4">Selected Channel</div>
              <div className="d-flex align-items-center py-2">

                {selectedChannel.WebIconPath ?
                  <img
                    className="pe-4 entertainment__webIcon select-channel"
                    src={`${selectedChannel.WebIconPath}`}
                  />
                  : <img
                    className="pe-4 entertainment__webIcon select-channel"
                    src={'../../../images/channels/unknown.png'}
                    />

                }
                <div>
                  <div className="fw-bold">{selectedChannel.WebName}
                    <FontAwesomeIcon
                      className="ms-3 text-secondary"
                      icon={faPen}
                      onClick={() => {
                        handleShowAvailableChannels();
                      }}
                    />
                  </div>
                  <div className="text-muted">{`Channel: ${selectedChannel.ChannelID}`}</div>
                </div>
              </div>
            </>
            :
            <Button
              className="w-100 my-4"
              onClick={() => {
                handleShowAvailableChannels()
              }}
            >
              Select a Channel
            </Button>
          }

          <Modal
            className="m-0"
            onHide={handleCloseAvailableChannels}
            show={showAvailableChannels}
          >
            <Modal.Header closeButton>
              <Modal.Title>Your Channels</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AvaliableChannels closeModal={handleCloseAvailableChannels} />
            </Modal.Body>
          </Modal>
        </Card.Body>

        <Button
          className="w-100"
          disabled={!selectedChannel}
          onClick={openConfirmationModal}
        >
          Save Changes
        </Button>
        {selectedChannel &&
          <Modal
            onHide={closeConfirmationModal}
            show={showConfirmationModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to replace the whole schedule with "{selectedChannel.WebName}?""
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={closeConfirmationModal}
                variant="secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleReplaceAll(selectedChannel)}
                variant="primary"
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>
        }

      </Card.Body>
    </Card>
  );
};

export default ReplaceAll;
